import { TOGGLE_CHAT_LIST } from "../constants/actionTypes";

export function toggleChatList(status) {
  return {
    type: TOGGLE_CHAT_LIST,
    status,
  };
}
